module.exports = __webpack_public_path__ + "static/media/BOTON WEB_Instr de viento.75846964.png";